var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"type":"submit","small":"","color":"primary","loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(" Create Tournament ")])}
var staticRenderFns = []

export { render, staticRenderFns }